export default {
  id: 'vitalSign/RESPIRATION_RATE/v1',
  formSchema: {
    title: 'encounter:widget.vitalSigns.respirationRate',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'integer',
        minimum: 1,
        maximum: 999,
        title: 'encounter:widget.vitalSigns.respirationRate'
      }
    },
    iconClass: 'icon-sounds',
    measurement: 'bpm'
  },
  uiSchema: {
    id001: { 'ui:widget': 'customI18nNumericWidget' },
    'x-customClass': 'vital-signs-widget',
    'x-cancelBtnSize': 'sm',
    'x-saveBtnSize': 'sm'
  }
};
